import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tokenlyglobal.css';

const API_BASE_URL = 'https://tokenly.biswaas.com/api';

const SettingsDoctors = () => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);
    const [settings, setSettings] = useState({
        trun_out_time: '15',
        doc_fees: '',
        token_start_no: '1',
        is_ble_printer: false,
        can_print_token: true,
        can_next_skip: true,
        remark_text: '',
        printer_no: ''
    });

    const token = localStorage.getItem('tokenly_token');
    const user = JSON.parse(localStorage.getItem('tokenly_user') || '{}');

    useEffect(() => {
        if (!token || user.roleId !== 3) {
            // navigate('/login');
            // return;
        }
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/doctor-detail`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    page: 'docProfile',
                    itemId: user.doctorId
                }),
            });

            const data = await response.json();

            if (data.status && data.data) {
                const d = data.data;
                setSettings({
                    trun_out_time: d.trun_out_time ? d.trun_out_time.toString() : '15',
                    doc_fees: d.doc_fees ? d.doc_fees.toString() : '',
                    token_start_no: d.token_start_no ? d.token_start_no.toString() : '1',
                    is_ble_printer: d.is_ble_printer == 1 || d.is_ble_printer === true,
                    can_print_token: d.can_print_token == 1 || d.can_print_token === true,
                    can_next_skip: d.can_next_skip == 1 || d.can_next_skip === true,
                    remark_text: d.remark_text || '',
                    printer_no: d.printer_no || ''
                });
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const response = await fetch(`${API_BASE_URL}/user/saveUserSetting`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    trun_out_time: settings.trun_out_time,
                    doc_fees: settings.doc_fees,
                    token_start_no: settings.token_start_no,
                    is_ble_printer: settings.is_ble_printer,
                    can_print_token: settings.can_print_token,
                    can_next_skip: settings.can_next_skip,
                    remark_text: settings.remark_text,
                }),
            });

            const data = await response.json();

            if (data.status) {
                alert(data.message || 'Settings saved successfully!');
            } else {
                alert('Failed to save settings: ' + data.message);
            }
        } catch (error) {
            console.error('Error saving settings:', error);
            alert('Something went wrong. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    const handleChange = (name, value) => {
        setSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="settings-page">
            {/* Hero Section */}
            <section className="contact-hero d-flex align-items-center position-relative overflow-hidden" style={{ minHeight: '250px' }}>
                <div className="contact-hero-overlay" style={{ background: 'linear-gradient(135deg, rgba(17,24,39,0.9) 0%, rgba(31,41,55,0.8) 100%)', position: 'absolute', inset: 0, zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2 }}>
                    <h1 className="display-5 fw-bold text-white mb-2">Doctor <span className="text-warning">Settings</span></h1>
                    <p className="text-light opacity-75 mb-0 max-w-600">
                        Configure your daily operations, consultation fees, and token management preferences.
                    </p>
                </div>
            </section>

            <div className="container-md py-5">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <form onSubmit={handleSave} className="row g-4">

                            {/* Operational Settings Card */}
                            <div className="col-md-7">
                                <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
                                    <div className="card-header bg-white border-0 pt-4 px-4 pb-0">
                                        <h5 className="fw-bold mb-0 d-flex align-items-center">
                                            <i className="bi bi-briefcase text-primary me-2"></i>
                                            Operational Controls
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="row g-4">
                                            <div className="col-md-6">
                                                <label className="form-label small fw-bold text-muted text-uppercase">Turn Out Time (Min)</label>
                                                <div className="input-group">
                                                    <span className="input-group-text bg-light border-0"><i className="bi bi-clock"></i></span>
                                                    <input
                                                        type="number"
                                                        className="form-control bg-light border-0 py-2"
                                                        value={settings.trun_out_time}
                                                        onChange={(e) => handleChange('trun_out_time', e.target.value)}
                                                        placeholder="e.g. 15"
                                                    />
                                                </div>
                                                <small className="text-muted mt-1 d-block">Approximate time per patient</small>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small fw-bold text-muted text-uppercase">Consultation Fee (INR)</label>
                                                <div className="input-group">
                                                    <span className="input-group-text bg-light border-0">₹</span>
                                                    <input
                                                        type="number"
                                                        className="form-control bg-light border-0 py-2"
                                                        value={settings.doc_fees}
                                                        onChange={(e) => handleChange('doc_fees', e.target.value)}
                                                        placeholder="e.g. 500"
                                                    />
                                                </div>
                                                <small className="text-muted mt-1 d-block">Fee shown to patients</small>
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label small fw-bold text-muted text-uppercase">Token Start Number</label>
                                                <div className="input-group">
                                                    <span className="input-group-text bg-light border-0"><i className="bi bi-hash"></i></span>
                                                    <input
                                                        type="number"
                                                        className="form-control bg-light border-0 py-2"
                                                        value={settings.token_start_no}
                                                        onChange={(e) => handleChange('token_start_no', e.target.value)}
                                                        placeholder="e.g. 1"
                                                    />
                                                </div>
                                                <small className="text-muted mt-1 d-block">The first token number for each shift</small>
                                            </div>
                                            <div className="col-12 mt-4">
                                                <label className="form-label small fw-bold text-muted text-uppercase">Remark / Instructions</label>
                                                <textarea
                                                    className="form-control bg-light border-0 py-2"
                                                    rows="4"
                                                    placeholder="This will be printed on the token receipt..."
                                                    value={settings.remark_text}
                                                    onChange={(e) => handleChange('remark_text', e.target.value)}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Preferences & Toggles Card */}
                            <div className="col-md-5">
                                <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden bg-white">
                                    <div className="card-header bg-white border-0 pt-4 px-4 pb-0">
                                        <h5 className="fw-bold mb-0 d-flex align-items-center">
                                            <i className="bi bi-sliders text-primary me-2"></i>
                                            Preferences
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="list-group list-group-flush">
                                            <div className="list-group-item border-0 px-0 py-3 bg-transparent d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="fw-bold fs-6">Bluetooth Printer Connect</div>
                                                    {/* <div className="small text-muted">Enable connection to BLE printers</div> */}
                                                </div>
                                                <div className="form-check form-switch custom-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={settings.is_ble_printer}
                                                        onChange={(e) => handleChange('is_ble_printer', e.target.checked)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="list-group-item border-0 px-0 py-3 bg-transparent d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="fw-bold fs-6">Can Print Token</div>
                                                    {/* <div className="small text-muted">Automatically print when generated</div> */}
                                                </div>
                                                <div className="form-check form-switch custom-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={settings.can_print_token}
                                                        onChange={(e) => handleChange('can_print_token', e.target.checked)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="list-group-item border-0 px-0 py-3 bg-transparent d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="fw-bold fs-6">Can Update Token</div>
                                                    {/* <div className="small text-muted">Allow staff to skip/update tokens</div> */}
                                                </div>
                                                <div className="form-check form-switch custom-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={settings.can_next_skip}
                                                        onChange={(e) => handleChange('can_next_skip', e.target.checked)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {settings.printer_no && (
                                            <div className="mt-4 p-3 rounded-3 bg-light border border-light-subtle d-flex align-items-center">
                                                <i className="bi bi-printer fs-4 text-primary me-3"></i>
                                                <div>
                                                    <div className="small text-muted text-uppercase fw-bold ls-1" style={{ fontSize: '0.65rem' }}>Active Printer</div>
                                                    <div className="fw-bold font-monospace">{settings.printer_no}</div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="mt-auto pt-5">
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100 py-3 rounded-3 fw-bold shadow-sm d-flex align-items-center justify-content-center transition-all"
                                                disabled={isSaving}
                                                style={{ letterSpacing: '0.5px' }}
                                            >
                                                {isSaving ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                                        SAVING...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-check2-circle me-2"></i>
                                                        SAVE SETTINGS
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

            <style>{`
                .settings-page {
                    background-color: #f9fafb;
                    min-height: 100vh;
                }
                .custom-switch .form-check-input {
                    width: 3rem;
                    height: 1.5rem;
                    cursor: pointer;
                }
                .custom-switch .form-check-input:checked {
                    background-color: #059669;
                    border-color: #059669;
                }
                .max-w-600 {
                    max-width: 600px;
                }
                .ls-1 {
                    letter-spacing: 1px;
                }
                .transition-all {
                    transition: all 0.3s ease;
                }
                .card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .card:hover {
                    box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
                }
                .input-group-text {
                    color: #6b7280;
                }
                .form-control:focus {
                    box-shadow: none;
                    background-color: #fff !important;
                    border: 1px solid #3b82f6 !important;
                }
            `}</style>
        </div>
    );
};

export default SettingsDoctors;
